import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { SearchApp } from './components/search-app'
import { IContentProps, DefaultContentProps } from './models/content-props';
import { ContentApiState, contentApiReducerWithDefault } from './ducks/content-api';
import { SearchApiState, searchApiReducer } from './ducks/search-api';
import { fetchMiddleware } from './middleware/fetch-middleware';
import { Query } from './functions/query';

export interface ISearchAppState {
    contentState: ContentApiState<IContentProps>
    searchResults: SearchApiState
}

export const rootReducer = combineReducers<ISearchAppState>({
    contentState: contentApiReducerWithDefault({ props: DefaultContentProps }),
    searchResults: searchApiReducer
})

const searchMount = document.getElementById('search-app');
const contentId = (window as any).bootstrap.contentId;
const dateSortRelevanceFilter = (window as any).bootstrap.dateSortRelevanceFilter;

// Attach Redux extension and add any middleware (just fetch here)
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(
        fetchMiddleware,
    )
));

if (searchMount) {
    ReactDOM.render(
        <Provider store={store}>
            <SearchApp
                contentId={contentId}
                initialParams={Query.getParams()}
                setQueryParams={Query.setParams}
                dateSortRelevanceFilter={dateSortRelevanceFilter}
            />
        </Provider>, searchMount);
}